<template>
  <div v-if="isAuthorized" class="mobile-header">

    <button class="btn mobile-header-menu-btn" data-bs-toggle="offcanvas" data-bs-target="#mobile-menu">
      <span class="mobile-button"></span>
    </button>

    <div v-if="$route.name === 'Home'" class="search-house-input">
      <div class="input-with-cross">
        <div class="search-input">
          <input v-model="searchInput"
                 id="search-input"
                 type="text"
                 class="form-control home-search"
                 placeholder="Поиск дома"
                 aria-autocomplete="both"
                 aria-haspopup="false"
                 autocapitalize="off"
                 autocomplete="off"
                 role="combobox"
                 spellcheck="false"
          >

        </div>
        <span v-if="searchInput" class="ic-cross" @click="searchInput = ''"></span>
        <label for="search-input" class="search-logo ic-search"></label>
      </div>
    </div>
  </div>

  <div class="offcanvas offcanvas-start" tabindex="-1" id="mobile-menu">
    <div class="offcanvas-header">
      <div class="user-info">
        <div class="user-header-photo"><span class="ic-user-default"></span></div>
        <span v-if="username" class="user-header-name">{{ username }}</span>
      </div>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <header-buttons @close-mobile-menu="closeMobileMenu"/>
    </div>
  </div>

</template>

<script>

import {useStore} from "vuex";
import {computed} from "vue";
import {useRouter} from "vue-router";
import HeaderButtons from "@/components/HeaderButtons";
import {Offcanvas} from "bootstrap";

export default {
  name: "MobileHeader",
  components: {HeaderButtons},
  props: {
    isAuthorized: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const store = useStore(),
      router = useRouter()

    const searchInput = computed({
      get: () => store.state.housesList.searchInput,
      set: newVal => {
        if (newVal) {
          router.replace({name: 'Home', query: {search: newVal}})
        } else {
          router.replace({name: 'Home'})
        }
        store.commit("housesList/setCurrentPage", 1)
        store.dispatch('housesList/searchHouses', newVal)
      }
    })

    return {
      searchInput,
      username: store.getters["user/getUsername"]
    }
  },
  mounted() {
    this.mobileMenu = new Offcanvas(document.getElementById('mobile-menu'))
  },
  methods: {
    closeMobileMenu() {
      this.mobileMenu.hide()
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-header {
  width: 100%;
  height: 60px;
  margin-bottom: .5em;
  display: flex;
  justify-content: space-between;

  & > .btn {
    height: 100%;
    padding: 0 .75em;
    margin-right: .5em;
    background-color: var(--common-background-shape);
    display: flex;
    align-items: center;
    box-shadow: var(--common-content-box-shadow);

    .mobile-button {
      width: calc(60px - 1.5em);
      height: 2px;
      display: block;
      background: var(--default-icon-color);
      border-radius: 1.5px;
      position: relative;

      &:before, &:after {
        content: '';
        width: 100%;
        height: 2px;
        position: absolute;
        border-radius: 1.5px;
        left: 0;
        background: var(--default-icon-color);
      }

      &:before {
        top: -8px;
      }

      &:after {
        top: 8px;
      }
    }
  }

  .search-house-input {
    display: flex;
    align-items: stretch;
    flex-grow: 1;

    .input-with-cross {
      position: relative;
      width: 100%;
      display: flex;
      align-items: stretch;
      background-color: var(--common-background-shape);
      box-shadow: var(--common-content-box-shadow);
      border-radius: 20px;

      .search-input {
        width: 100%;
        margin: 0 40px 0 50px;
        display: flex;
        align-items: center;

        input {
          padding: 0 4px;
          height: min-content;
          background: transparent;
          border: none;
        }
      }


      span, label {
        width: 25px;
        position: absolute;
        right: 10px;
        cursor: pointer;
        height: 100%;
        top: 0;
        display: flex;
        align-items: center;

        &.ic-search {
          left: 15px;

          &:hover {
            color: var(--default-icon-color);
          }
        }
      }
    }
  }
}

.offcanvas {
  .user-info {
    display: flex;
    flex-direction: row;

    .user-header-name {
      background: transparent;
      border-radius: 20px;
      padding: .8rem;
      line-height: 100%;
      display: flex;
      align-items: center;
    }

    .user-header-photo {
      height: 40px;
      background: transparent;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 30px;

        &:hover {
          color: var(--default-icon-color);
        }
      }
    }
  }
}


</style>
